var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "notification-icon-calendar.bb15d5db.png","uri@2x": __webpack_public_path__ + "notification-icon-calendar.6df84acb.png","uri@3x": __webpack_public_path__ + "notification-icon-calendar.fad5a7d8.png",
    width: 20,
    height: 22
});